module.exports = __webpack_public_path__ + "media/images/undraw_punctuality-fe0c21324f9a40075c6e01359970d51b.svg";